{
  "customAddress": "Enter custom address",
  "title": "<h1>Please confirm your address.</h1>",
  "subtitle": "<span>We could not proceed with the information you provided. Please use one of the suggested addresses below or enter a custom address.</span>",
  "select-option": "<span><strong>Please select an option:</strong></span>",
  "recommended": "(recommended)",
  "custom": "Enter custom address",
  "inputs": {
    "street_address": {
      "label": "Home Address",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [
        ["required", "is required"],
        ["minLength2", "is invalid"],
        ["notEmail", "is invalid"],
        ["notPOBox", "PO Box is not accepted", "ignore label"]
      ]
    },
    "city": {
      "label": "City",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [
        ["required", "is required"],
        ["minLength2", "is invalid"],
        ["notEmail", "is invalid"]
      ]
    },
    "region": {
      "label": "Province",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "Select Province",
      "validity": [
        ["required", "is required"],
        ["minLength2", "is invalid"],
        ["validRegionCA", "is invalid"]
      ]
    },
    "postal_code": {
      "label": "Postal Code",
      "isRequired": true,
      "showRequiredIcon": true,
      "mask": "A0A 0A0",
      "placeholder": "55555",
      "validity": [
        ["required", "is required"],
        ["minLength6", "is invalid"]
      ],
      "postProcess": "digitCharOnlyString"
    },
    "monthly_housing_cost": {
      "label": "Monthly Housing Cost",
      "maxLength": "10",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "$1,000",
      "symbol": "$",
      "validity": [["required", "is required"]],
      "postProcess": "priceInCents"
    },
    "primary_income_source": {
      "label": "Primary Source of Income",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "Select an option",
      "validity": [["required", "is required"]]
    },
    "occupation": {
      "label": "Occupation",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [["required", "is required"]]
    },
    "employment_duration": {
      "label": "Duration with Current Employer",
      "placeholder": "Select an option",
      "isRequired": true,
      "showRequiredIcon": true,
      "validity": [["required", "is required"]]
    }
  },
  "incomeSources": {
    "salaried": "Salaried",
    "self-employed": "Self Employed",
    "investments": "Investments",
    "other": "Other"
  },
  "employmentDurations": {
    "<1": "Less than 1 year",
    "1-2": "1 - 2 years",
    "3-5": "3 - 5 years",
    ">5": "Over 5 years"
  },
  "submit": "Continue"
}
